import * as yup from "yup";
import { ApiResponse } from "@typeDefinitions/Api";
import { APIMethods } from "@typeDefinitions/enums";
import { getDataAPI } from "@utils/api";
import {
  PatientSearchResource,
  patientSearchResourceSchema,
} from "@client/resources/PatientSearchResource";

export const getClientsAPI = async (
  params?: URLSearchParams,
): Promise<ApiResponse<PatientSearchResource[]>> => {
  const response = await getDataAPI(
    "/dietitian/clinic/patients/search",
    APIMethods.GET,
    undefined,
    params,
  );
  const responseSchema = yup.object().shape({
    data: yup.array().of(patientSearchResourceSchema).required(),
  });
  return await responseSchema.validate(response);
};

export type ClientDto = PatientSearchResource;
